module.exports = {
  DEAD_RECKONING: 'dead-reckoning',
  REAL_GPS: 'real-gps',
  NO_GPS: 'no-gps',
};
